import Modal from "react-native-modal";
import { View, Text } from "@constants/Themed";
import React from 'react';
import styles from "@stylesheet";
import { Progress } from "tamagui";
import AnimatedLottieView from "@utils/lottieAnimation";

interface UploadModalProps {
  status: number;
  visible: boolean;
  setVisible?: Function;
}

const UploadModal = ({ status, visible, setVisible }: UploadModalProps) => {
  return (
    <Modal isVisible={visible}>
      <View style={[styles.modalContainerAuth, styles.centerEverything, { width: '80%', maxHeight: '70%', gap: 20 }]}>
        <View style={{ flex: 1 }}>
          <AnimatedLottieView source={require('@assets/animations/upload.json')} autoPlay style={{ height: '100%', width: '100%' }} />
        </View>
        <View style={{ paddingHorizontal:'10%', width: '50%', margin: 50, flex:1, minHeight: 100, maxWidth:'80%' }}>
          <Progress value={status} color={'rgb(90,192,234)'} style={{ alignContent: 'center', alignItems: 'center', alignSelf: 'center' }} />
        </View>
        <Text>Uploading your data</Text>
      </View>
    </Modal>
  );
}

// Memoize the component to optimize re-renders based on status and visible
const MemoizedUploadModal = React.memo(UploadModal, (prevProps, nextProps) => {
  // Only re-render if status or visible properties change
  return prevProps.status === nextProps.status && prevProps.visible === nextProps.visible;
});

export default MemoizedUploadModal;
